module.exports = __webpack_public_path__ + "img/devops.37b2ab78.png";